module.exports = __webpack_public_path__ + "img/call-circle-red.04df2e5.svg";